// "Is this marketplace ad still real?" — one answer, shared by the candidate rows and the
// linked-source cards.
//
// The thresholds and the two Hebrew strings are the app's EXISTING staleness vocabulary,
// lifted from ListingsMatchRow (yad2 > 7d ⇒ probably removed, madlan > 3d ⇒ probably old,
// webot > 365d ⇒ probably old) rather than invented here. A second set of numbers would
// mean the same ad reads "removed" on the board and "fine" in the picker, which is worse
// than either answer on its own.
//
// `updatedTime` is when the SCRAPE last re-saw the ad, which is exactly the liveness
// signal — it is bumped on every sighting even when nothing about the listing changed.
import { getEpochTimeFromDaysAgo } from "utils/listingsMatch/data";

export type ListingStaleness = "fresh" | "potentiallyOld" | "potentiallyRemoved";

/** i18n keys, so both surfaces render the same words the listings board already uses. */
export const STALENESS_LABEL_KEY: Record<Exclude<ListingStaleness, "fresh">, string> = {
  potentiallyRemoved: "listingsMatch.listingIsPotentiallyRemoved",
  potentiallyOld: "listingsMatch.listingIsPotentiallyOld"
};

export function listingStaleness(
  origin: string | undefined | null,
  updatedTimeMs: number | null | undefined
): ListingStaleness {
  // No timestamp is not evidence of staleness. Saying "probably removed" about an ad we
  // simply have no sighting date for would be a warning she cannot act on.
  if (typeof updatedTimeMs !== "number" || !isFinite(updatedTimeMs)) return "fresh";
  if (origin === "yad2") return updatedTimeMs < getEpochTimeFromDaysAgo(7) ? "potentiallyRemoved" : "fresh";
  if (origin === "madlan") return updatedTimeMs < getEpochTimeFromDaysAgo(3) ? "potentiallyOld" : "fresh";
  if (origin === "webot") return updatedTimeMs < getEpochTimeFromDaysAgo(365) ? "potentiallyOld" : "fresh";
  return "fresh";
}
